import ProductCard from "../components/ProductCard";
import { useEffect, useState } from "react";

function WomenPage() {
  const [womenProducts, setWomenProducts] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/api/products`);
      const products = await data.json();
      setWomenProducts(
        products.filter((product) => product.category === "women"),
      );
    }
    fetchData();
  }, []);

  return (
    <div>
      <section className="collection-section">
        <h2> Women's Collection </h2>
        <div className="product-grid">
          {womenProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default WomenPage;
